import { render, staticRenderFns } from "./CusPaymentsHead.vue?vue&type=template&id=6b2e39c2&scoped=true"
import script from "./CusPaymentsHead.vue?vue&type=script&lang=js"
export * from "./CusPaymentsHead.vue?vue&type=script&lang=js"
import style0 from "./CusPaymentsHead.vue?vue&type=style&index=0&id=6b2e39c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e39c2",
  null
  
)

export default component.exports